<ng-container *ngIf="markAsSeen(); else welcomeTemplate">
    <acorn-vertical-stepper [selectedIndex]="selectedStep()!" (selectedIndexChange)="onSelectStep($event)">
        <cdk-step *ngFor="let category of categories" [label]="category.name" [state]="category.status | displayStepState">
            <acorn-nested-vertical-stepper
                *ngIf="category.id === selectedParentCategory()?.id!"
                [parentId]="category.id"
                [activeParentId]="selectedParentCategory()?.id!"
                [selectedIndex]="selectedChildStep()!"
                (selectedIndexChange)="onSelectChildStep($event)"
            >
                <cdk-step
                    *ngFor="let subStep of category.childItems!"
                    [label]="subStep.name"
                    [state]="subStep.status === CategoryStatus.Complete ? 'done' : ''"
                ></cdk-step>
            </acorn-nested-vertical-stepper>
        </cdk-step>
    </acorn-vertical-stepper>
    <div class="step__body">
        <ng-container *ngIf="selectedChildStep() !== 8 && selectedChildStep() !== 9 && selectedChildStep() !== 10">
            <ng-container [ngSwitch]="selectedTemplateType()">
                <acorn-dependants
                    *ngSwitchCase="TemplateType.MultiAnswerQuestion"
                    [questions]="selectedQuestions()"
                    [parentCategory]="selectedParentCategory()!"
                    [currentCategory]="selectedCategory()!"
                    [applicationId]="applicationId"
                    [applicationUsers]="applicationUsers"
                    [isFileNotes]="isFileNotes"
                    [isAppComplete]="isAppComplete"
                    [applicationAboutYou]="latestApplicationAboutYou()"
                    (async)="onUpdateApplicationAboutYou($event)"
                    (back)="onHandleBack()"
                    (next)="onBeforeHandleNext()"
                ></acorn-dependants>

                <acorn-last-review
                    *ngSwitchCase="TemplateType.LastReview"
                    [questions]="selectedQuestions()"
                    [parentCategory]="selectedParentCategory()!"
                    [currentCategory]="selectedCategory()!"
                    [answerSelections]="answerSelections"
                    [applicationId]="applicationId"
                    [applicationUsers]="applicationUsers"
                    [isFileNotes]="isFileNotes"
                    [isAppComplete]="isAppComplete"
                    [applicationAboutYou]="latestApplicationAboutYou()"
                    (async)="onUpdateApplicationAboutYou($event)"
                    (back)="onHandleBack()"
                    (next)="onBeforeHandleNext()"
                ></acorn-last-review>
                <acorn-common-answer-new
                    *ngSwitchCase="TemplateType.SuperFunds"
                    [answerSelections]="answerSelections"
                    [questions]="selectedQuestions()"
                    [primaryQuestion]="selectedPrimaryQuestion()"
                    [secondaryQuestion]="secondaryPrimaryQuestions()!"
                    [parentCategory]="selectedParentCategory()!"
                    [currentCategory]="selectedCategory()!"
                    [applicationId]="applicationId"
                    [applicationUsers]="applicationUsers"
                    [isFileNotes]="isFileNotes"
                    [isAppComplete]="isAppComplete"
                    [applicationAboutYou]="latestApplicationAboutYou()"
                    (async)="onUpdateApplicationAboutYou($event)"
                    (back)="onHandleBack()"
                    (next)="onBeforeHandleNext()"
                >
                </acorn-common-answer-new>
                <ng-container *ngSwitchDefault>
                    <acorn-common-answer
                        [answerSelections]="answerSelections"
                        [questions]="selectedQuestions()"
                        [primaryQuestion]="selectedPrimaryQuestion()"
                        [parentCategory]="selectedParentCategory()!"
                        [currentCategory]="selectedCategory()!"
                        [applicationId]="applicationId"
                        [applicationUsers]="applicationUsers"
                        [isFileNotes]="isFileNotes"
                        [isAppComplete]="isAppComplete"
                        [applicationAboutYou]="latestApplicationAboutYou()"
                        (async)="onUpdateApplicationAboutYou($event)"
                        (back)="onHandleBack()"
                        (next)="onBeforeHandleNext()"
                    ></acorn-common-answer>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container>
            <acorn-wealth-building-blocks *ngIf="selectedChildStep() === 8"></acorn-wealth-building-blocks>

            <acorn-wealth-health-score
                *ngIf="selectedChildStep() === 9"
                [wealthHealthScore]="wealthHealthScore()!"
                [isDashboardApp]="isDashboardApp"
            ></acorn-wealth-health-score>

            <acorn-wealth-happy-screen
                *ngIf="selectedChildStep() === 10"
                [wealthHealthScore]="wealthHealthScore()!"
                [isDashboardApp]="isDashboardApp"
            ></acorn-wealth-happy-screen>
        </ng-container>
        <acorn-application-navigation
            *ngIf="selectedChildStep() === 8 || selectedChildStep() === 9"
            (back)="onHandleBack()"
            (next)="onBeforeHandleNext()"
        ></acorn-application-navigation>
        <acorn-application-navigation
            *ngIf="selectedChildStep() === 10"
            (back)="onBack()"
            (next)="onNext()"
        ></acorn-application-navigation>
    </div>
    <div></div>
</ng-container>

<ng-template #welcomeTemplate>
    <div></div>

    <acorn-welcome-screen imageName="wealth-health-score.svg" title="Wealth Health" [description]="description" estimatedTime="10">
        <acorn-application-navigation (back)="back.emit()" (next)="onInitializeStep()"></acorn-application-navigation>
    </acorn-welcome-screen>

    <div></div>
</ng-template>
